<template>
  <div class="title-container"><h2 :class="fieldClass">{{contentTitle}}</h2></div>
</template>
<script>
export default {
  props:{
    text: {
      type: String
    },
    fieldClass:''
  },
  computed:{
    contentTitle: function() {
      return this.text
    }
  }
}
</script>
<style lang="scss">
@import '@/app/styles/index.scss';
// here you can add custom styles for your field
.title-container{
  width:100%;
  
  padding: 20px;
  h2{
    color: $color-pink;
    // text-align: center;
  }
}
</style>